import { boolean, create, Describe } from 'superstruct';

export const DocumentIsOpenValidator: Describe<boolean> = boolean();

export function makeDocumentIsOpen(raw: unknown) {
  try {
    const formResponse = create(raw, DocumentIsOpenValidator);
    return formResponse;
  } catch (err) {
    console.error(err);
  }
}
